/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetReeferCheckListQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetReeferCheckListQuery = {
  __typename?: 'Query',
  cargo?: {
    __typename?: 'Cargo',
    id: number,
    loadingReference?: string | null,
    containerNumber?: string | null,
    desiredTemperature?: number | null,
    reeferCheckType?: Types.ReeferCheckType | null,
    containerType?: {
      __typename?: 'ContainerType',
      isoTypeCode: string,
      displayCode?: string | null
    } | null,
    voyage?: {
      __typename?: 'Voyage',
      id: number,
      voyageNumber: string,
      ship: {
        __typename?: 'Ship',
        name: string
      }
    } | null,
    firstLoadingAction?: {
      __typename?: 'CargoAction',
      id: number,
      call?: {
        __typename?: 'Call',
        id: number,
        pta?: number | null,
        ata?: number | null,
        location: {
          __typename?: 'Location',
          id: number,
          description: string
        }
      } | null
    } | null,
    lastDischargingAction?: {
      __typename?: 'CargoAction',
      id: number,
      call?: {
        __typename?: 'Call',
        id: number,
        pta?: number | null,
        ata?: number | null,
        location: {
          __typename?: 'Location',
          id: number,
          description: string
        }
      } | null
    } | null,
    reeferChecklist?: {
      __typename?: 'ReeferCheckList',
      location?: string | null,
      setPoint?: number | null,
      plugin?: {
        __typename?: 'ReeferPlugin',
        id?: number | null,
        timestamp?: number | null,
        temperature?: number | null
      } | null,
      plugout?: {
        __typename?: 'ReeferPlugin',
        id?: number | null,
        timestamp?: number | null,
        temperature?: number | null
      } | null,
      checks?: Array<{
        __typename?: 'ReeferPlugin',
        id?: number | null,
        temperature?: number | null,
        timestamp?: number | null
      }> | null
    } | null,
    charter?: {
      __typename?: 'SalesCharter',
      debtor: {
        __typename?: 'Relation',
        name: string
      }
    } | null
  } | null
};


export const GetReeferCheckListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReeferCheckList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loadingReference"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"desiredTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reeferCheckType"}},{"kind":"Field","name":{"kind":"Name","value":"reeferChecklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"setPoint"}},{"kind":"Field","name":{"kind":"Name","value":"plugin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plugout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetReeferCheckListQuery, GetReeferCheckListQueryVariables>;